import { isExpiredAuth } from '@src/services/auth';
import { ACCESS_TOKEN_KEY, getAccessToken, removeCookie } from '@src/services/storage/cookies';
import { parseToken } from '@utils/index';
import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import AppHeader from './header';
import { Paper } from '@mui/material';

const Header = styled.header`
  background-color: #121212;
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  > div {
    width: 1000px;
    margin: 0 auto;
    height: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      align-items: center;
      gap: 25px;
      color: #ffffff;
      .active {
        font-weight: bold;
      }
    }
  }
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: #f9fcff;
  min-height: 100vh;
`;

const Container = styled(Paper)`
  width: 740px;
  margin: 0 auto;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 50px 20px;

`;

export default function Layout() {
  const location = useLocation();
  const navitate = useNavigate();
  const [isSignin, setIsSignIn] = useState<boolean>();
  const [isAdmin, setIsAdmin] = useState(false);

  const authCheck = async () => {
    if (await isExpiredAuth()) {
      navitate('/signin');
      setIsSignIn(false);
      setIsAdmin(false);
      return;
    }
    const token = getAccessToken();
    const info = parseToken(token.access);
    setIsAdmin(info.is_admin);
    setIsSignIn(true);
  };

  useEffect(() => {
    if (!location.pathname.includes('signin')) {
      authCheck();
    }
  }, [location]);
  return (
    <Background>
      {/* <Header>
        <div>
          <div>
            {isAdmin && (
              <>
                <NavLink to="/admin/add-booking-place">Add place</NavLink>
                <NavLink to="/admin/booking-place-list">Place List</NavLink>
                <NavLink to="/admin/schedule/request">Request List</NavLink>
                &nbsp;&nbsp;&nbsp;
              </>
            )}
            <NavLink to="/schedule">Schedule</NavLink>
            <NavLink to="/schedule/request">Request list</NavLink>
          </div>
          <div>{isSignin === true && <a onClick={handleSignOut}>Sign out</a>}</div>
        </div>
      </Header> */}
      <AppHeader isAdmin={isAdmin} />
      <Container
        variant="elevation"
        elevation={6}
      >
        <Outlet></Outlet>
      </Container>
    </Background>
  );
}
